"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiElementGroup = void 0;
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./kpi-element-group.less");
let KpiElementGroup = class KpiElementGroup extends react_1.Component {
    render() {
        const { greenElement, redElement, lightRedElement, yellowElement, renderElement } = this.props;
        return (React.createElement("div", { className: "kpi-element-group" },
            React.createElement("div", { className: "kpi-element-group__small-element-group" },
                lightRedElement && renderElement(lightRedElement),
                React.createElement("div", { className: "kpi-element-group__lower-small-element" }, renderElement(redElement))),
            React.createElement("div", { className: "kpi-element-group__small-element-group" },
                renderElement(yellowElement),
                React.createElement("div", { className: "kpi-element-group__lower-small-element" }, renderElement(greenElement)))));
    }
};
KpiElementGroup = __decorate([
    mobx_react_1.observer
], KpiElementGroup);
exports.KpiElementGroup = KpiElementGroup;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi-header/kpi-element-group/kpi-element-group.tsx
// module id = 3762
// module chunks = 0